import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

const PrivacyPage = () => {
  const { language } = useLanguage();

  const content = language === 'fr' ? {
    title: 'Politique de confidentialit\u00e9',
    lastUpdated: 'Derni\u00e8re mise \u00e0 jour\u00a0: 30 juillet 2026',
    sections: [
      {
        title: '1. Responsable de la protection des renseignements personnels',
        text: 'Conform\u00e9ment \u00e0 la Loi 25 du Qu\u00e9bec, le responsable d\u00e9sign\u00e9 est\u00a0:',
        list: [
          'Alain Poirier',
          'Responsable de la protection des renseignements personnels',
          '\u00c9tuis s\u00e9curis\u00e9s MyGuardPod / MyGuardPod',
          'Baie-Comeau, Qu\u00e9bec, Canada',
          'contact@myguardpod.com'
        ]
      },
      {
        title: '2. Renseignements recueillis via le formulaire de contact',
        text: 'Lorsque vous nous \u00e9crivez via le formulaire de contact, nous recueillons uniquement les renseignements que vous fournissez volontairement\u00a0: votre nom, votre adresse courriel, le sujet et le contenu de votre message. Aucun renseignement m\u00e9dical personnel n\u2019est requis. Merci de ne pas transmettre de diagnostic, num\u00e9ro de prescription ni tout autre renseignement m\u00e9dical confidentiel.'
      },
      {
        title: '3. Renseignements techniques et t\u00e9moins',
        text: 'Lors de votre visite, des renseignements techniques peuvent \u00eatre recueillis automatiquement par nos outils d\u2019analyse\u00a0: adresse IP tronqu\u00e9e, type de navigateur, type d\u2019appareil, syst\u00e8me d\u2019exploitation, pages consult\u00e9es, dur\u00e9e des visites, source d\u2019acc\u00e8s, langue d\u2019affichage et \u00e9v\u00e9nements de clic (par exemple, ouverture d\u2019un lien Etsy). Certains de ces \u00e9l\u00e9ments reposent sur des t\u00e9moins (cookies).'
      },
      {
        title: '4. Outils et fournisseurs r\u00e9ellement utilis\u00e9s',
        text: 'Le site utilise actuellement les outils suivants\u00a0:',
        list: [
          'Google Analytics 4 (Google Ireland Limited / Google LLC) \u2014 statistiques de fr\u00e9quentation agr\u00e9g\u00e9es et \u00e9v\u00e9nements de clic. Les donn\u00e9es peuvent \u00eatre trait\u00e9es hors du Canada.',
          'PostHog \u2014 mesures d\u2019utilisation agr\u00e9g\u00e9es fournies par la plateforme d\u2019h\u00e9bergement Emergent. Aucun enregistrement de session ni capture de saisie de formulaire n\u2019est activ\u00e9. Les donn\u00e9es peuvent \u00eatre trait\u00e9es hors du Canada.',
          'Emergent Agent (assets.emergent.sh) \u2014 plateforme d\u2019h\u00e9bergement et infrastructure du site.',
          'Etsy \u2014 les achats sont trait\u00e9s enti\u00e8rement sur la boutique Etsy officielle. La politique d\u2019Etsy s\u2019applique lorsqu\u2019un lien y m\u00e8ne.',
          'Resend \u2014 service d\u2019envoi de courriel utilis\u00e9 uniquement pour la r\u00e9ception des messages du formulaire de contact.'
        ]
      },
      {
        title: '5. Finalit\u00e9s de la collecte',
        text: 'Les renseignements sont utilis\u00e9s uniquement pour\u00a0:',
        list: [
          'r\u00e9pondre \u00e0 vos demandes envoy\u00e9es via le formulaire de contact\u00a0;',
          'am\u00e9liorer l\u2019exp\u00e9rience et la performance du site\u00a0;',
          'mesurer la fr\u00e9quentation de fa\u00e7on agr\u00e9g\u00e9e\u00a0;',
          'assurer la s\u00e9curit\u00e9 technique du site\u00a0;',
          'respecter les obligations l\u00e9gales applicables.'
        ]
      },
      {
        title: '6. Consentement aux t\u00e9moins',
        text: 'Avant votre consentement, aucun t\u00e9moin analytique non essentiel n\u2019est activ\u00e9 et aucun \u00e9v\u00e9nement analytique n\u2019est envoy\u00e9. La banni\u00e8re de consentement propose trois choix \u00e9quivalents\u00a0: Accepter, Refuser les t\u00e9moins non essentiels, Personnaliser. Vous pouvez retirer ou modifier votre consentement \u00e0 tout moment via le lien \u00ab\u00a0Pr\u00e9f\u00e9rences de confidentialit\u00e9\u00a0\u00bb dans le pied de page.'
      },
      {
        title: '7. Conservation et destruction',
        text: 'Les messages du formulaire de contact sont conserv\u00e9s aussi longtemps que n\u00e9cessaire pour r\u00e9pondre \u00e0 votre demande et pour r\u00e9f\u00e9rence l\u00e9gitime, puis d\u00e9truits ou anonymis\u00e9s. Les donn\u00e9es analytiques agr\u00e9g\u00e9es sont conserv\u00e9es selon les param\u00e8tres par d\u00e9faut de chaque fournisseur (Google Analytics\u00a0: 14 mois\u00a0; PostHog\u00a0: selon la configuration de la plateforme d\u2019h\u00e9bergement).'
      },
      {
        title: '8. Transfert hors du Qu\u00e9bec et du Canada',
        text: 'Certains fournisseurs (Google Analytics, PostHog, Emergent, Resend) peuvent traiter les renseignements techniques dans d\u2019autres juridictions, notamment aux \u00c9tats-Unis et en Union europ\u00e9enne. En utilisant le site et en acceptant les t\u00e9moins non essentiels, vous consentez \u00e0 ce transfert.'
      },
      {
        title: '9. Vos droits',
        text: 'Sous r\u00e9serve de la loi applicable, vous avez le droit\u00a0: d\u2019acc\u00e9der aux renseignements personnels vous concernant, de les faire rectifier, de retirer votre consentement, de vous opposer au traitement et de porter plainte aupr\u00e8s de la Commission d\u2019acc\u00e8s \u00e0 l\u2019information du Qu\u00e9bec. Pour exercer un droit, \u00e9crivez au responsable \u00e0 contact@myguardpod.com.'
      },
      {
        title: '10. Modifications de la politique',
        text: 'Cette politique peut \u00eatre mise \u00e0 jour \u00e0 l\u2019occasion. La date de derni\u00e8re mise \u00e0 jour figure en haut de la page. Toute modification importante sera signal\u00e9e visiblement sur le site.'
      }
    ]
  } : {
    title: 'Privacy Policy',
    lastUpdated: 'Last updated: July 30, 2026',
    sections: [
      {
        title: '1. Person in charge of personal-information protection',
        text: 'In accordance with Quebec\u2019s Law 25, the designated person in charge is:',
        list: [
          'Alain Poirier',
          'Person in charge of personal-information protection',
          '\u00c9tuis s\u00e9curis\u00e9s MyGuardPod / MyGuardPod',
          'Baie-Comeau, Qu\u00e9bec, Canada',
          'contact@myguardpod.com'
        ]
      },
      {
        title: '2. Information collected through the contact form',
        text: 'When you write to us through the contact form, we only collect the information you voluntarily provide: your name, email address, subject and message content. No personal medical information is required. Please do not submit diagnoses, prescription numbers or any other confidential medical information.'
      },
      {
        title: '3. Technical information and cookies',
        text: 'During your visit, technical information may be collected automatically by our analytics tools: truncated IP address, browser type, device type, operating system, pages visited, visit duration, referring source, display language and click events (for example, opening an Etsy link). Some of these elements rely on cookies.'
      },
      {
        title: '4. Tools and providers actually used',
        text: 'The website currently uses the following tools:',
        list: [
          'Google Analytics 4 (Google Ireland Limited / Google LLC) \u2014 aggregate traffic statistics and click events. Data may be processed outside Canada.',
          'PostHog \u2014 aggregate usage measurements provided by the Emergent hosting platform. Session recording and form-input capture are not enabled. Data may be processed outside Canada.',
          'Emergent Agent (assets.emergent.sh) \u2014 hosting platform and site infrastructure.',
          'Etsy \u2014 purchases are processed entirely on the official Etsy shop. Etsy\u2019s own policy applies whenever a link takes you there.',
          'Resend \u2014 email delivery service used only to receive contact-form messages.'
        ]
      },
      {
        title: '5. Purposes of collection',
        text: 'Information is used only to:',
        list: [
          'respond to requests submitted through the contact form;',
          'improve the site\u2019s experience and performance;',
          'measure traffic on an aggregate basis;',
          'ensure the technical security of the site;',
          'meet applicable legal obligations.'
        ]
      },
      {
        title: '6. Cookie consent',
        text: 'Before your consent, no non-essential analytics cookies are activated and no analytics events are sent. The consent banner offers three equivalent choices: Accept, Reject non-essential cookies, Customize. You can withdraw or modify your consent at any time via the \u201cPrivacy preferences\u201d link in the footer.'
      },
      {
        title: '7. Retention and destruction',
        text: 'Contact-form messages are kept as long as necessary to respond to your request and for legitimate reference, then destroyed or anonymized. Aggregate analytics data is retained according to each provider\u2019s default settings (Google Analytics: 14 months; PostHog: according to the hosting platform configuration).'
      },
      {
        title: '8. Transfer outside Qu\u00e9bec and Canada',
        text: 'Some providers (Google Analytics, PostHog, Emergent, Resend) may process technical information in other jurisdictions, notably in the United States and the European Union. By using the site and accepting non-essential cookies, you consent to this transfer.'
      },
      {
        title: '9. Your rights',
        text: 'Subject to applicable law, you have the right to: access personal information about you, request its correction, withdraw your consent, object to processing and file a complaint with the Commission d\u2019acc\u00e8s \u00e0 l\u2019information du Qu\u00e9bec. To exercise a right, write to the person in charge at contact@myguardpod.com.'
      },
      {
        title: '10. Changes to this policy',
        text: 'This policy may be updated from time to time. The last-updated date is shown at the top of the page. Any material change will be signalled visibly on the site.'
      }
    ]
  };

  return (
    <main className="pt-20 sm:pt-24">
      <section className="bg-neutral-50 py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="text-center max-w-3xl mx-auto"
          >
            <h1 className="font-outfit font-black text-4xl sm:text-5xl tracking-tight text-[#1a1a1a] mb-4">
              {content.title}
            </h1>
            <p className="font-manrope text-neutral-500">{content.lastUpdated}</p>
          </motion.div>
        </div>
      </section>

      <section className="py-16 sm:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-8">
          {content.sections.map((section, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.03 }}
            >
              <h2 className="font-outfit font-bold text-xl text-[#1a1a1a] mb-3">{section.title}</h2>
              <p className="font-manrope text-neutral-600 leading-relaxed whitespace-pre-line">{section.text}</p>
              {section.list && (
                <ul className="mt-3 space-y-1.5 list-disc pl-6 text-neutral-600 font-manrope">
                  {section.list.map((li, li_i) => (
                    <li key={li_i}>{li}</li>
                  ))}
                </ul>
              )}
            </motion.div>
          ))}
        </div>
      </section>
    </main>
  );
};

export default PrivacyPage;
